import Carousel from 'react-slick';

// ✅ Custom arrows ใช้ SVG แทน slick font
const PrevArrow = ({ onClick }) => (
  <button className='slick-prev slick-arrow' onClick={onClick} aria-label='Previous'>
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M15 18L9 12L15 6' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  </button>
);

const NextArrow = ({ onClick }) => (
  <button className='slick-next slick-arrow' onClick={onClick} aria-label='Next'>
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M9 18L15 12L9 6' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  </button>
);

const Carousels = ({ children, slideShow = 1, responsiveShow = 3, autoplay = true, vertical = false, autoplaySpeed, infinite = true }) => {
  const settings = {
    dots: true,
    speed: 1000,
    infinite: infinite,
    slidesToShow: slideShow || 3,
    slidesToScroll: 1,
    autoplay: autoplay,
    autoplaySpeed: autoplaySpeed || 3000,
    pauseOnHover: true,
    vertical: vertical,
    verticalSwiping: vertical,
    swipeToSlide: vertical,
    // ✅ ใช้ custom arrow แทน slick default (ที่ใช้ font)
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: slideShow || 1,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: vertical ? 2 : responsiveShow,
          slidesToScroll: 1,
          initialSlide: 2,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: vertical ? 2 : 1,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  };

  return <Carousel {...settings}>{children}</Carousel>;
};

export default Carousels;
